var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "captiontextsstyle" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          attrs: {
            "label-width": "80px",
            model: _vm.datas,
            size: "small",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标题内容" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入标题", "show-word-limit": "" },
                model: {
                  value: _vm.datas.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "name", $$v)
                  },
                  expression: "datas.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "描述内容" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入要说明的文字，最多 100 字",
                  maxlength: "100",
                },
                model: {
                  value: _vm.datas.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "description", $$v)
                  },
                  expression: "datas.description",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "显示位置" } }, [
            _c("div", { staticClass: "weiz" }, [
              _c("i", {
                staticClass: "zdy-icon icon-font-left",
                class: _vm.datas.positions === "left" ? "active" : "",
                on: {
                  click: function ($event) {
                    _vm.datas.positions = "left"
                  },
                },
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "zdy-icon icon-font-center",
                class: _vm.datas.positions === "center" ? "active" : "",
                on: {
                  click: function ($event) {
                    _vm.datas.positions = "center"
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "标题大小",
                prop: "titleSize",
                "hide-required-asterisk": true,
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  placeholder: "请输入标题文字大小",
                  maxlength: 2,
                },
                model: {
                  value: _vm.datas.titleSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "titleSize", _vm._n($$v))
                  },
                  expression: "datas.titleSize",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "描述大小",
                prop: "descriptionSize",
                "hide-required-asterisk": true,
              },
            },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: "请输入描述文字大小" },
                model: {
                  value: _vm.datas.descriptionSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "descriptionSize", _vm._n($$v))
                  },
                  expression: "datas.descriptionSize",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "标题粗细",
                prop: "titleWeight",
                "hide-required-asterisk": true,
              },
            },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: "请输入标题粗细" },
                model: {
                  value: _vm.datas.titleWeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "titleWeight", _vm._n($$v))
                  },
                  expression: "datas.titleWeight",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "描述粗细",
                prop: "descriptionWeight",
                "hide-required-asterisk": true,
              },
            },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: "请输入描述粗细" },
                model: {
                  value: _vm.datas.descriptionWeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "descriptionWeight", _vm._n($$v))
                  },
                  expression: "datas.descriptionWeight",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "框体高度" } },
            [
              _c("el-slider", {
                attrs: {
                  max: 100,
                  min: 1,
                  "input-size": "mini",
                  "show-input": "",
                },
                model: {
                  value: _vm.datas.wordHeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "wordHeight", $$v)
                  },
                  expression: "datas.wordHeight",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "左右边距" } },
            [
              _c("el-slider", {
                attrs: {
                  max: 100,
                  min: 0,
                  "input-size": "mini",
                  "show-input": "",
                },
                model: {
                  value: _vm.datas.wordMargin,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "wordMargin", $$v)
                  },
                  expression: "datas.wordMargin",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "标题颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.titleColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "titleColor", $$v)
                  },
                  expression: "datas.titleColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "描述颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.descriptionColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "descriptionColor", $$v)
                  },
                  expression: "datas.descriptionColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.backgroundColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "backgroundColor", $$v)
                  },
                  expression: "datas.backgroundColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "wid", attrs: { label: "底部分割线" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.datas.borderBott ? "显示" : "隐藏") +
                  "\n      "
              ),
              _c("el-checkbox", {
                model: {
                  value: _vm.datas.borderBott,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "borderBott", $$v)
                  },
                  expression: "datas.borderBott",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "wid", attrs: { label: "查看更多" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.datas.more.show ? "显示" : "隐藏") +
                  "\n      "
              ),
              _c("el-checkbox", {
                model: {
                  value: _vm.datas.more.show,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas.more, "show", $$v)
                  },
                  expression: "datas.more.show",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.datas.more.show ? true : false,
                  expression: "datas.more.show ? true : false",
                },
              ],
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.datas.more.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.datas.more, "type", $$v)
                    },
                    expression: "datas.more.type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("样式一")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("样式二")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("样式三")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { height: "10px" } }),
              _vm._v(" "),
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.datas.more.type === 2 ? false : true,
                    expression: "datas.more.type === 2 ? false : true",
                  },
                ],
                staticStyle: { width: "110px", margin: "15px" },
                attrs: { type: "text", size: "mini" },
                model: {
                  value: _vm.datas.more.text,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas.more, "text", $$v)
                  },
                  expression: "datas.more.text",
                },
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { height: "10px" } }),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳转链接" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-left": "18px" },
                      on: { change: _vm.handleHttpTypeChange },
                      model: {
                        value: _vm.datas.more.httpType,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas.more, "httpType", $$v)
                        },
                        expression: "datas.more.httpType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 10 } }, [
                        _vm._v("内部链接"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 11 } }, [
                        _vm._v("外部链接"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.datas.more.httpType === 10
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { "margin-top": "10px", width: "100%" },
                          attrs: {
                            placeholder: "请选择内部页面",
                            filterable: "",
                            clearable: "",
                            loading: _vm.loadingPageList,
                          },
                          on: { change: _vm.handlePageChange },
                          model: {
                            value: _vm.datas.more.http,
                            callback: function ($$v) {
                              _vm.$set(_vm.datas.more, "http", $$v)
                            },
                            expression: "datas.more.http",
                          },
                        },
                        _vm._l(_vm.pageList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      )
                    : _c("el-input", {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          placeholder: "请输入跳转链接",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.datas.more.http,
                          callback: function ($$v) {
                            _vm.$set(_vm.datas.more, "http", $$v)
                          },
                          expression: "datas.more.http",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }